import SelectDropdown from "../../../../../components/generic/selectdropdown";
import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../stylesheets/components/dowloadHoldingReports/DPtransactionFormDesk.scss";
import { useSelector } from "react-redux";
import moment from "moment";
import di from "../../di/servicelocator";
import { accountDetails } from "@di";
import { pnlDownloadDate, previousDay } from "@domains/utils/reportDates";
const DPtransactionFormDesk = (props) => {
    var _a, _b, _c;
    const [startDate, setStartDate] = useState(previousDay);
    const [endDate, setEndDate] = useState(previousDay);
    const [emailCheck, setEmailCheck] = useState(false);
    const [selectedDpId, setSelectedDpId] = useState((_a = props.dpIds[0]) === null || _a === void 0 ? void 0 : _a.value);
    const _startcalendar = useRef(null);
    const _endcalendar = useRef(null);
    const startDatePicker = (e) => {
        if (_startcalendar.current) {
            _startcalendar.current.setOpen(true);
        }
    };
    var dpIdArray = [
        {
            value: "12032300 - 00670170 (CDSL EBL)",
            display: "12032300 - 00670170 (CDSL EBL)",
        },
        // {
        //   value: "IN303719 - 10689142 (NSDL EBL)",
        //   display: "IN303719 - 10689142 (NSDL EBL)",
        // },
    ];
    const endDatePicker = (e) => {
        if (_endcalendar.current) {
            _endcalendar.current.setOpen(true);
        }
    };
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [showMailInput, setshowMailInput] = useState(false);
    const openMailInput = (e) => {
        setshowMailInput(e.target.checked);
    };
    const [emailList, setEmailList] = useState([]);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const dpTransactionLoader = useSelector((state) => state.holdingReport.dpTransactionLoader);
    React.useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            setEmailList(defaultEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    const getDPTransactionHistoryRecords = () => {
        if (startDate && endDate && selectedDpId) {
            const payload = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                status: "ALL",
                dpid: selectedDpId,
            };
            di.holdingReport.getDPTransactionHistory(payload);
        }
    };
    const submitDpTransactionRequest = async () => {
        if (startDate && endDate && selectedDpId) {
            props.setShowLoader(true);
            props.setDpTransactionReport(true);
            const payload = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                accountCode: await accountDetails.getAccountCode(),
                dpid: selectedDpId,
            };
            const response = await di.holdingReport.submitSpecificRequest(payload);
            if (response !== "" && response !== null) {
                props.setShowLoader(false);
                props.setDownloadSuccess(true);
                props.setOperation("email");
                props.setDpTransactionSucessMsg(response);
            }
        }
    };
    React.useEffect(() => {
        getDPTransactionHistoryRecords();
    }, [startDate, endDate, selectedDpId]);
    const setDpId = (event) => {
        setSelectedDpId(event.target.value);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm" },
            React.createElement("div", { className: "header d-flex align-item-flex-top" },
                React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-timeout-holding" })),
                React.createElement("h2", null, "Generate Report")),
            React.createElement("form", { className: "customFormSection" },
                React.createElement("div", null,
                    React.createElement("div", { className: "" },
                        React.createElement("div", { className: "customFormSection_field dateWrap " },
                            React.createElement("div", { className: "DateBoxfromToDate horizontalLine pb-3" },
                                React.createElement("div", { className: "DateBoxfrom" },
                                    React.createElement("label", { htmlFor: "date", className: "form-label" }, "From Date"),
                                    React.createElement("div", { className: "input-group yearDropdown singleDatePicker holdingReportsDate" },
                                        React.createElement(DatePicker, { selected: startDate, onChange: (date) => setStartDate(date), ref: _startcalendar, dateFormat: "d-MMM-yy", showYearDropdown: true, showMonthDropdown: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), scrollableYearDropdown: true, maxDate: previousDay, minDate: pnlDownloadDate, yearDropdownItemNumber: previousDay.getFullYear() -
                                                pnlDownloadDate.getFullYear() +
                                                1 }),
                                        React.createElement("a", { className: "input-group-append", onClick: startDatePicker },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                React.createElement("span", null, "Change"))))),
                                React.createElement("div", { className: "DateBoxTo" },
                                    React.createElement("label", { htmlFor: "date", className: "form-label" }, "To Date"),
                                    React.createElement("div", { className: "input-group yearDropdown singleDatePicker holdingReportsDate" },
                                        React.createElement(DatePicker, { selected: endDate, onChange: (date) => setEndDate(date), ref: _endcalendar, dateFormat: "d-MMM-yy", showYearDropdown: true, showMonthDropdown: true, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), scrollableYearDropdown: true, maxDate: previousDay, minDate: pnlDownloadDate, yearDropdownItemNumber: previousDay.getFullYear() -
                                                pnlDownloadDate.getFullYear() +
                                                1 }),
                                        React.createElement("a", { className: "input-group-append", onClick: endDatePicker },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                React.createElement("span", null, "Change"))))))),
                        React.createElement("div", { className: "customFormSection_field pt-4" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "DP ID"),
                            React.createElement(SelectDropdown, { id: "selectoption", selected: true, defaultValue: (_b = props.dpIds[0]) === null || _b === void 0 ? void 0 : _b.value, selectedValue: selectedDpId ? selectedDpId : (_c = props.dpIds[0]) === null || _c === void 0 ? void 0 : _c.value, options: props.dpIds, onChangeEvent: (e) => setDpId(e), className: "CustomCommonDropdown", downarrow: "edel-icon-arrow-down", dropdownOptions: props.dpIds, placeholderClassName: "" })),
                        React.createElement("div", { className: "customFormSection_field pt-4" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Get Report As"),
                            React.createElement("div", { className: "checkbox pt-1" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckDefault", checked: downloadCheck, onChange: (e) => {
                                            setDownloadCheck(e.target.checked);
                                        }, disabled: true }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" }, "Download")),
                                React.createElement("div", { className: "form-check", onClick: openMailInput },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", disabled: true, checked: emailCheck, onChange: (e) => {
                                            setEmailCheck(e.target.checked);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email")))),
                        showMailInput && (React.createElement("div", { className: "customFormSection_field" },
                            React.createElement("div", null, emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                    return (React.createElement("div", { className: "mail-input mt-4" },
                                        React.createElement("label", { htmlFor: "", className: "form-label" }, "Regd. Email ID"),
                                        React.createElement("input", { type: "email", className: "form-control mt-1 customTextbox", placeholder: "Enter email address", pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$", value: el, onChange: (e) => setCurrEmailValue(e.target.value) }))
                                    // <li key={idx} className="mail_label_body_item">
                                    //   {el}
                                    //   <span
                                    //     className="mail_label_close"
                                    //     onClick={() =>
                                    //       setEmailList((emailList) =>
                                    //         emailList.filter(
                                    //           (_, i) => i !== emailList.length - 1
                                    //         )
                                    //       )
                                    //     }
                                    //   >
                                    //     <i className="edel-icon-rounded-close"></i>
                                    //   </span>
                                    // </li>
                                    );
                                })))))))),
                    React.createElement("div", { className: "" },
                        React.createElement("button", { disabled: !(startDate && endDate && selectedDpId) || dpTransactionLoader, className: "custom_btn btn btn-primary bg-secondarynavy mt-4", type: "button", onClick: () => {
                                submitDpTransactionRequest();
                            } }, "Submit")))))));
};
export default DPtransactionFormDesk;
